document.addEventListener('DOMContentLoaded', function () {
/* variant on click feature image change */
  window.selectedVOProductImage = null;

  function cleanUrl(url) {
    if (!url) return '';
    return url.split('?')[0];
  }

  function getImageFromLabel(label) {
    if (!label) return null;

    var bg = label.style.backgroundImage || label.style.background;
    if (!bg) return null;

    var match = bg.match(/url\(["']?(.*?)["']?\)/);
    return match ? match[1] : null;
  }

  function makeHighQualityImage(imageUrl) {
    if (!imageUrl) return null;

    try {
      var url = new URL(imageUrl);
      var encoded = url.pathname.replace('/', '');

      var decoded = atob(encoded);
      var json = JSON.parse(decoded);

      if (json.edits) {
        delete json.edits;
      }

      var newEncoded = btoa(JSON.stringify(json));
      return url.origin + '/' + newEncoded;
    } catch (e) {
      return imageUrl;
    }
  }

  function updateMainProductImage(imageUrl) {
    if (!imageUrl) return;

    var highQualityUrl = makeHighQualityImage(imageUrl);
    window.selectedVOProductImage = highQualityUrl;

    var mainImage =
      document.querySelector('.product__media img') ||
      document.querySelector('.product-media img') ||
      document.querySelector('.product__media-item img') ||
      document.querySelector('[data-media-id] img');

    if (!mainImage) return;

    mainImage.src = highQualityUrl;
    mainImage.srcset = '';
    mainImage.setAttribute('data-src', highQualityUrl);
    mainImage.setAttribute('data-zoom', highQualityUrl);

    var imageLink = mainImage.closest('a');
    if (imageLink) {
      imageLink.href = highQualityUrl;
      imageLink.setAttribute('data-pswp-src', highQualityUrl);
      imageLink.setAttribute('data-src', highQualityUrl);
    }
  }

  function updateProductModalImage(clickedMediaToggle) {
    var imageUrl = window.selectedVOProductImage;
    if (!imageUrl || !clickedMediaToggle) return;

    var clickedMediaWrapper = clickedMediaToggle.closest('[data-media-id], .product__modal-opener, .product-media-container');
    var clickedImage = clickedMediaWrapper ? clickedMediaWrapper.querySelector('img') : null;

    // Only change modal when the clicked image is the custom VO selected image.
    // If user clicks another normal gallery image, do nothing.
    if (!clickedImage || cleanUrl(clickedImage.src) !== cleanUrl(imageUrl)) {
      return;
    }

    var mediaId = clickedMediaToggle.getAttribute('data-media-id');

    setTimeout(function () {
      var modal =
        document.querySelector('#ProductModal-template--20618925768792__main') ||
        document.querySelector('product-modal') ||
        document.querySelector('.product-media-modal');

      if (!modal) return;

      var modalMedia = null;

      if (mediaId) {
        modalMedia = modal.querySelector('[data-media-id="' + mediaId + '"]');
      }

      var modalImage = modalMedia ? modalMedia.querySelector('img') : null;

      // Fallback: only update the first visible modal image, not all images
      if (!modalImage) {
        modalImage = modal.querySelector('img');
      }

      if (!modalImage) return;

      modalImage.src = imageUrl;
      modalImage.srcset = '';
      modalImage.setAttribute('data-src', imageUrl);
      modalImage.setAttribute('data-zoom', imageUrl);

      var modalLink = modalImage.closest('a');

      if (modalLink && modalLink.hasAttribute('href')) {
        modalLink.href = imageUrl;
        modalLink.setAttribute('data-pswp-src', imageUrl);
        modalLink.setAttribute('data-src', imageUrl);
      }

    }, 250);
  }

  function handleColorChange(input) {
    if (!input) return;

    var label = document.querySelector('label[for="' + input.id + '"]');
    var imageUrl = getImageFromLabel(label);

    updateMainProductImage(imageUrl);
  }

  document.addEventListener('change', function (event) {
    var input = event.target;

    if (!input.classList.contains('bcpo-front-image-option')) return;

    handleColorChange(input);
  });

  document.addEventListener('click', function (event) {
    var label = event.target.closest('.bcpo-front-image-label');

    if (label) {
      setTimeout(function () {
        var inputId = label.getAttribute('for');
        var input = document.getElementById(inputId);

        handleColorChange(input);
      }, 100);
    }

    var mediaToggle = event.target.closest('.product__media-toggle, .product__modal-opener, modal-opener');

    if (mediaToggle) {
      updateProductModalImage(mediaToggle);
    }
  });

  
/* variant on click feature image change end */
});

document.addEventListener("DOMContentLoaded", function () {
  const DIGITIZING_VARIANT_ID = 33302226075736;
  const TARGET_OPTION_TITLE = "Embroidery (+$30 Digitizing Fees)";
  const NON_TARGET_OPTION_TITLE = "Embroidery (Without Digitizing Fees)";

  let isAdding = false;

  function itemHasText(item, text) {
    if (!item || !text) return false;

    const title = item.title || "";
    const variantTitle = item.variant_title || "";

    return title.includes(text) || variantTitle.includes(text);
  }

  function checkAndAddDigitizing() {
    if (isAdding) return;

    fetch("/cart.js")
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) return;

        const hasTargetVariant = cart.items.some(function (item) {
          return itemHasText(item, TARGET_OPTION_TITLE);
        });

        const hasNonTargetVariant = cart.items.some(function (item) {
          return itemHasText(item, NON_TARGET_OPTION_TITLE);
        });

        const hasDigitizingFee = cart.items.some(function (item) {
          return Number(item.variant_id) === Number(DIGITIZING_VARIANT_ID);
        });

        console.log({
          hasTargetVariant,
          hasNonTargetVariant,
          hasDigitizingFee,
          isAdding
        });

        if (
          hasTargetVariant &&
          !hasDigitizingFee &&
          !hasNonTargetVariant
        ) {
          isAdding = true;

          return fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify({
              id: DIGITIZING_VARIANT_ID,
              quantity: 1,
              properties: {
                "Added by": "Digitizing Fees"
              }
            })
          });
        }
      })
      .then(function (res) {
        if (!res) return;
        if (!res.ok) throw new Error("Failed to add digitizing fee");

        // Faster than full location.reload()
        window.location.href = "/cart";
      })
      .catch(function (err) {
        console.error("Digitizing fee script error:", err);
        isAdding = false;
      });
  }

  checkAndAddDigitizing();
});

document.addEventListener('DOMContentLoaded', function () {
  function getMinQty(selectedVal) {
    const qtyMap = {
      'Leather patch': 48,
      'Embroidered patch': 48,
      'Embroidery (+$30 Digitizing Fees)': 24,
      'Embroidery (Without Digitizing Fees)': 24,
      'Blank (No Embroidery)': 48
    };

    return qtyMap[selectedVal] || 1;
  }

  function getEmbroiderySelect() {
    return document.querySelector('#bcpo-select-option-1');
  }

  function getQtyInput() {
    return document.querySelector(
      'input[name="quantity"], .quantity__input, quantity-input input'
    );
  }

  function updateQuantityByEmbroidery() {
    const embroiderySelect = getEmbroiderySelect();
    const qtyInput = getQtyInput();

    if (!embroiderySelect || !qtyInput) return;

    const selectedVal = embroiderySelect.value;
    const minQty = getMinQty(selectedVal);

    qtyInput.value = minQty;
    qtyInput.setAttribute('min', minQty);

    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function enforceMinimumQuantity() {
    const embroiderySelect = getEmbroiderySelect();
    const qtyInput = getQtyInput();

    if (!embroiderySelect || !qtyInput) return;

    const minQty = getMinQty(embroiderySelect.value);
    const currentQty = parseInt(qtyInput.value, 10);

    qtyInput.setAttribute('min', minQty);

    if (isNaN(currentQty) || currentQty < minQty) {
      qtyInput.value = minQty;

      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.id === 'bcpo-select-option-1') {
      updateQuantityByEmbroidery();
    }

    if (
      event.target &&
      event.target.matches('input[name="quantity"], .quantity__input, quantity-input input')
    ) {
      enforceMinimumQuantity();
    }
  });

  document.addEventListener('input', function (event) {
    if (
      event.target &&
      event.target.matches('input[name="quantity"], .quantity__input, quantity-input input')
    ) {
      enforceMinimumQuantity();
    }
  });

  document.addEventListener('submit', function (event) {
    if (event.target && event.target.matches('form[action*="/cart/add"]')) {
      enforceMinimumQuantity();
    }
  });

  function waitForBCPO(attemptsLeft = 30) {
    const embroiderySelect = getEmbroiderySelect();
    const qtyInput = getQtyInput();

    if (embroiderySelect && qtyInput) {
      updateQuantityByEmbroidery();
    } else if (attemptsLeft > 0) {
      setTimeout(function () {
        waitForBCPO(attemptsLeft - 1);
      }, 500);
    }
  }

  waitForBCPO();
});
